import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

export default function initPhotoSwipeLightbox() {
  const arrowPrevSvg = '<svg aria-hidden="true" focusable="false" class="text-white inline" role="img" width="30" height="60" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M18.2 273l-17-17 17-17L171.8 85.4l17-17 33.9 33.9-17 17L93.1 232 424 232l24 0 0 48-24 0L93.1 280 205.8 392.6l17 17-33.9 33.9-17-17L18.2 273z"/></svg>';
  const arrowNextSvg = '<svg aria-hidden="true" focusable="false" class="text-white inline" role="img" width="30" height="60" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M429.8 273l17-17-17-17L276.2 85.4l-17-17-33.9 33.9 17 17L354.9 232 24 232 0 232l0 48 24 0 330.8 0L242.2 392.6l-17 17 33.9 33.9 17-17L429.8 273z"/></svg>';
  const zoomSvg = '<svg aria-hidden="true" focusable="false" class="text-white" role="img" width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"/></svg>';
  const closeSvg = '<svg aria-hidden="true" focusable="false" class="text-white" role="img" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>';

  const lightbox = new PhotoSwipeLightbox({
    gallery: '.js-gallery',
    children: 'a.js-gallery-img',
    arrowPrevSVG: arrowPrevSvg,
    arrowNextSVG: arrowNextSvg,
    zoomSVG: zoomSvg,
    closeSVG: closeSvg,
    pswpModule: PhotoSwipe,
    showHideAnimationType: 'fade',
  });

  function messageFn(action: string, src: string) {
    if (src.search('vimeo') > 0) { // case for Vimeo
      return JSON.stringify({
        method: action,
      });
    }
    if (src.search('youtube') > 0) { // case for YouTube
      return JSON.stringify({
        event: 'command',
        func: `${action}Video`,
      });
    }
    if (src.search('v.qq') > 0) { // case for YouTube
      return `bind${action}`;
    } // case for other video services (hurriyet videos, dailymotion etc..)
    return action;
  }

  lightbox.addFilter('itemData', (itemData) => {
    // @ts-ignore
    if (itemData.element.dataset.pswpType && itemData.element.dataset.pswpType === 'video') {
      // set a custom parameter to use for the iframe
      // @ts-ignore
      const previewUrl = itemData.element.href;

      if (previewUrl) {
        // eslint-disable-next-line no-param-reassign
        itemData.previewUrl = previewUrl;
      }
    }
    return itemData;
  });
  lightbox.on('contentLoad', (e) => {
    const { content } = e;

    if (content.type === 'video') {
      e.preventDefault();

      // Create a container for iframe
      // and assign it to the `content.element` property
      content.element = document.createElement('div');
      content.element.className = 'pswp__preview-container video-lightbox';

      const iframe = document.createElement('iframe');

      iframe.setAttribute('allow', 'xr-spatial-tracking; fullscreen; autoplay');
      iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
      iframe.setAttribute('frameBorder', '0');
      iframe.setAttribute('width', '100%');
      iframe.setAttribute('height', '100%');
      iframe.src = content.data.previewUrl;
      content.element.appendChild(iframe);
    }
  });
  lightbox.on('contentDeactivate', (e) => {
    const { content } = e;
    if (content.type === 'video') {
      // if the slide deactivates, pause the video
      // @ts-ignore
      const iframe = content.element.querySelector('iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(messageFn('pause', iframe.src), '*');
      }
    }
  });
  lightbox.on('contentActivate', (e) => {
    const { content } = e;
    if (content.type === 'video') {
      // if the slide deactivates, play the video
      // @ts-ignore
      const iframe = content.element.querySelector('iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(messageFn('play', iframe.src), '*');
      }
    }
  });
  lightbox.on('contentAppend', ({ content }) => {
    // @ts-ignore
    if (content.type === 'video' && !content.slide.isActive) {
      // by default autoplay is set, but should be removed if the active slide isn't the video
      // @ts-ignore
      const iframe = content.element.querySelector('iframe');
      if (iframe && iframe.src) {
        iframe.src = iframe.src.replace('autoplay=1', '');
      }
    }
  });
  lightbox.init();

  document.querySelectorAll('.product-gallery').forEach((gallery) => {
    const swiperCarousel = gallery.querySelector('.product-slider');

    if (swiperCarousel) {
      // @ts-ignore
      const { swiper } = swiperCarousel;
      lightbox.on('change', () => {
        const { pswp } = lightbox;
        // @ts-ignore
        if (swiper.slides.length - 1 >= pswp.currIndex) {
          // @ts-ignore
          swiper.slideTo(pswp.currIndex, 0, false);
        }
      });
    }
  });

  // @ts-ignore
  document.querySelectorAll('[data-pswp-trigger]').forEach((trigger: HTMLElement) => {
    const gallery = trigger.dataset.pswpTrigger;
    const index = trigger.dataset.pswpIndex;
    if (gallery && index) {
      trigger.addEventListener('click', () => {
        // @ts-ignore
        lightbox.loadAndOpen(Number(index - 1), {
          gallery: document.querySelector(gallery),
        });
      });
    }
  });
}
